import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject, forkJoin } from 'rxjs';

@Injectable()
export class NotificationEngineService {

    constructor() { }
}
